import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DeleteAccountDialog } from './DeleteAccountDialog'

export function AccountSettings() {
  const { t } = useTranslation()
  const [dialogOpen, setDialogOpen] = useState(false)

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold text-ink">{t('account.settings.title')}</h1>

      <section className="rounded-xl border border-danger/30 bg-danger/5 p-6">
        <h2 className="text-base font-semibold text-danger mb-1">Danger zone</h2>
        <p className="text-sm text-muted mb-4">Permanently delete your account and all associated data.</p>
        <button
          onClick={() => setDialogOpen(true)}
          className="rounded-lg border border-danger text-danger font-semibold py-2 px-4 hover:bg-danger hover:text-white focus:outline-none focus:ring-2 focus:ring-danger transition"
        >
          {t('account.settings.deleteButton')}
        </button>
      </section>

      <DeleteAccountDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </div>
  )
}
